import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

function initFilterSliders() {
    const sliderElements = document.querySelectorAll('.js-filter-slider'),
        sliders = [];

    if (sliderElements.length) {
        sliderElements.forEach(slider => {
            const elem = slider.querySelector('.js-filter-slider-elem'),
                wrapper = elem.closest('.c-filter-slider'),
                maxValue = Number(slider.dataset.max),
                minValue = Number(slider.dataset.min),
                fromValue = Number(slider.dataset.from),
                toValue = Number(slider.dataset.to),
                sliderId = slider.dataset.id,
                fromInput = wrapper.querySelector(`#filter-slider-${sliderId}-from`),
                toInput = wrapper.querySelector(`#filter-slider-${sliderId}-to`);
                
            sliders[sliderId] = noUiSlider.create(elem, {
                start: [fromValue, toValue],
                range: {
                    'min': [minValue],
                    'max': [maxValue]
                },
                margin: 1,
                connect: true,
                tooltips: [
                    wNumb({
                        decimals: 0,
                    }),
                    wNumb({
                        decimals: 0,
                    })
                ],
                step: 1
            });

            sliders[sliderId].on('change', (values, handle) => {
                fromInput.value = Number(values[0]);
                toInput.value = Number(values[1]);

                Filter.submit();
            });

            fromInput.addEventListener('change', event => {
                event.preventDefault();

                const min = Number(fromInput.getAttribute('min')),
                    toInputValue = Number(toInput.value);

                let value = Number(fromInput.value),
                    setInput = false;

                if (value < min) {
                    value = min;
                    setInput = true;
                }
                else if (value > toInputValue) {
                    value = toInputValue;
                    setInput = true;
                }

                if (setInput) {
                    fromInput.value = value;
                }

                sliders[sliderId].set([value, null]);
            });

            toInput.addEventListener('change', event => {
                event.preventDefault();

                const max = Number(toInput.getAttribute('max')),
                    formInputValue = Number(fromInput.value);

                let value = Number(toInput.value),
                    setInput = false;

                if (value > max) {
                    value = max;
                    setInput = true;
                }
                else if (value < formInputValue) {
                    value = formInputValue;
                    setInput = true;
                }

                if (setInput) {
                    toInput.value = value;
                }

                sliders[sliderId].set([null, value]);
            });
        });
    }
}

$(function () {
    initFilterSliders();
});